import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IActivityItem } from './OrderDetails';
import { TableComponent } from '../TableComponent';
import { PaymentActivityTableRow } from './PaymentActivityTableRow';
import { Title } from '../developers/page-components/Title';
import { useOrdersContext } from '../../store/order/order-context';
import { numberFormatter } from '../../utils/utilities';

const COLUMNS = [
	{
		key: 'dateTime',
		title: 'ORDERS.DATE_TIME',
		additionalColumnClassName: 'w-100px'
	},
	{
		key: 'type',
		title: 'ORDERS.PAYMENT_TYPE'
	},
	{
		key: 'method',
		title: 'ORDERS.DESCRIPTION'
	},
	{
		key: 'amount',
		title: 'ORDERS.PAYMENT_TABLE_AMOUNT',
		additionalColumnClassName: 'w-90px'
	}
];

export const PaymentActivity: FC = () => {
	const { t } = useTranslation();
	const { orderContextState: { orderDetailsData }} = useOrdersContext();
	const { activityItems, currencySymbol, balanceToBePaid, totalBalancePaid, currency, amount } = orderDetailsData;

	const footerItems = [
		{
			name: 'ORDERS.ORDER_TOTAL',
			value: amount ? amount : 0
		},
		{
			name: 'ORDERS.TOTAL_BALANCE',
			value: totalBalancePaid ? totalBalancePaid : 0
		},
		{
			name: 'ORDERS.BALANCE',
			value: balanceToBePaid ? balanceToBePaid : 0
		}
	];

	return(
		<div className="card mt-6" data-cy="payment-activity-block">
			<div className="card-body">
				<Title title={t('ORDERS.PAYMENT_ACTIVITY')} additionalClass="fw-bolder fs-4"/>
			</div>
			<TableComponent
				column={COLUMNS}
				tableData={activityItems}
				getRowComponent={(row: IActivityItem, index ):JSX.Element => (
					<PaymentActivityTableRow
						key={`${row?.paymentTransactionId}-${index}`}
						currency={currencySymbol}
						{ ...row }
					/>
				)}/>
			<div className="card-body row">
				<div className="col" />
				{
					footerItems?.map(({ name, value }): JSX.Element => (
						<div
							className="col-3 d-flex flex-column justify-content-center align-items-center"
							key={name}
							data-cy="payment-activity-total-item"
						>
							<div className="text-muted mb-2 fs-9">
								{t(name)}
							</div>
							<div>
								<span className="fs-3 fw-bolder text-nowrap">
									{currencySymbol || ''}
									{numberFormatter(value)}
								</span>
								<span className="fs-8 text-muted ms-2">{currency || ''}</span>
							</div>
						</div>
					))
				}
				<div className="col" />
			</div>
		</div>
	);
};
